import api from './axios';

const PurchaseOrderService = {
  getPurchaseOrders: () => api.get('/api/v1/purchase-orders'),
  getPurchaseOrder: (id) => api.get(`/api/v1/purchase-orders/${id}`),
  createPurchaseOrder: (data) => api.post('/api/v1/purchase-orders', data),
  updatePurchaseOrder: (id, data) => api.patch(`/api/v1/purchase-orders/${id}`, data),
  deletePurchaseOrder: (id) => api.delete(`/api/v1/purchase-orders/${id}`),
  downloadPdf: (id) => api.get(`/api/v1/purchase-orders/${id}/pdf`, { responseType: 'blob' }),
  exportPurchaseOrders: (status = 'All') => api.get(`/api/v1/reports/purchase-orders/export?status=${status}`, { responseType: 'blob' }),
};

export default PurchaseOrderService;
